import React from "react";
import { useTranslation } from "react-i18next";
import type { TShowCaseTreeList } from "@app/types";

export const ShowCaseListIco = ({ e }: { e: any }) => {
  const { data }: { data: TShowCaseTreeList } = e;
  return <i className={`dx-icon dx-icon-file`} />;
};

export const ShowCaseListTitle = ({ e }: { e: any }) => {
  return <span>{(e.data as TShowCaseTreeList).title || "<showcase>"}</span>;
};
